import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

/** Rutas de administración de plataforma (solo rol root). */
export const rootAdminGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!(await auth.isRoot())) {
    router.navigate(['/home']);
    return false;
  }
  return true;
};
